export const environment = {
  name: "development",
  short_name: "dev",

  //specify the lighthouse base that we're going to use to authenticate against all our source/providers. Must not have trailing slash
  lighthouse_api_endpoint_base: 'https://lighthouse.fastenhealth.com',

  connect_base_domain: 'connect.fastenlabs.com',

  //used to specify the api server that we're going to use (can be relative or absolute). Must not have trailing slash
  // connect_api_endpoint_base: 'https://api.connect.fastenlabs.com/v1',
  // if relative, must start with /
  connect_api_endpoint_base: 'https://api.connect.fastenlabs.com/v1',
  connect_api_jwt_issuer_host: 'https://api.connect.fastenlabs.com/v1',
  identity_api_endpoint_base: 'https://identity.fastenlabs.com/v1',

  jwks_uri: 'https://cdn.fastenhealth.com/jwks/fasten-connect/dev.json',

};
